import { MessageSquare, Mic } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components/ui/button';

interface ModalitySelectProps {
  onSelect: (modality: 'text' | 'voice') => void;
}

export function ModalitySelect({ onSelect }: ModalitySelectProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm">
        <div className="rounded-2xl border border-border bg-card px-8 py-10 shadow-sm">
          <div className="mb-6 flex flex-col items-center gap-3">
            <div className="text-center">
              <h1 className="text-xl">{t('screening.modality.title')}</h1>
              <p className="mt-1 text-sm text-muted-foreground">
                {t('screening.modality.description')}
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <Button
              variant="outline"
              className="flex h-16 w-full items-center gap-3 text-base"
              onClick={() => {
                onSelect('text');
              }}
            >
              <div className="flex size-10 items-center justify-center rounded-full bg-primary/10">
                <MessageSquare className="size-5 text-primary" />
              </div>
              <div className="text-left">
                <div className="font-medium">{t('screening.modality.text')}</div>
                <div className="text-xs text-muted-foreground">
                  {t('screening.modality.textDescription')}
                </div>
              </div>
            </Button>

            <Button
              variant="outline"
              className="flex h-16 w-full items-center gap-3 text-base"
              onClick={() => {
                onSelect('voice');
              }}
            >
              <div className="flex size-10 items-center justify-center rounded-full bg-primary/10">
                <Mic className="size-5 text-primary" />
              </div>
              <div className="text-left">
                <div className="font-medium">{t('screening.modality.voice')}</div>
                <div className="text-xs text-muted-foreground">
                  {t('screening.modality.voiceDescription')}
                </div>
              </div>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
